/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdUnlinkedObjects =
  "/data_objects/:type_name/:external_id/unlinked_objects" as const;
